// preOrderService.js
// Production-ready service for merch pre-orders with Google Sheets and Stripe Checkout

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const preOrderService = {
  /**
   * Create a Stripe Checkout Session for merch items
   * Note: Order saving happens via webhook after successful payment
   */
  async createStripeCheckoutSession({ items, orderId, email, customerData }) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/checkout/session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          orderId,
          email,
          customerData, // Pass additional customer data for webhook processing
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create checkout session: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  /**
   * Get order status by ID (for future order lookup features)
   */
  async getOrderStatus(orderId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/preorders/${orderId}`);
      if (!response.ok) {
        throw new Error(`Failed to get order status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error getting order status:', error);
      throw error;
    }
  }
};

export default preOrderService;